<app-input-wrapper [value]="display()" [label]="label" [required]="required">
  <input type="text" readonly app-base-input [value]="display()" (click)="toggleActive()" />
</app-input-wrapper>

<div
  *ngIf="isActive()"
  class="absolute inset-0 z-10 bg-black opacity-50 md:hidden"
  (click)="toggleActive(); onTouch(true)"></div>
<div
  *ngIf="isActive()"
  class="absolute inset-0 z-50 mt-10 flex flex-col overflow-y-auto bg-white py-4 md:hidden">
  <div class="flex items-center gap-4 px-4">
    <button app-icon-button name="arrow-narrow-left" (click)="toggleActive()"></button>
    <h1 class="prose-display-lg font-semibold">{{ header }}</h1>
  </div>
  <div class="flex-1 overflow-y-auto">
    <div
      *ngIf="searchable"
      class="prose-text-sm mx-4 my-5 flex items-center gap-2.5 rounded-[80px] border border-neutral-200 bg-neutral-100 p-3 text-neutral-700">
      <app-icon name="search" />
      <input
        type="text"
        [placeholder]="placeholder"
        class="prose-text-sm w-0 flex-1 border-none bg-inherit p-0 outline-none placeholder:text-neutral-500 focus:ring-0"
        (keyup)="updateQuery($event)" />
    </div>
    <div *ngFor="let option of filteredOptions()">
      <div
        class="flex cursor-pointer items-center bg-white px-4 py-2 hover:bg-neutral-200"
        (click)="select(option)">
        <span>
          {{ option.label }}
        </span>
        <img
          [src]="
            isSelected(option)
              ? 'assets/images/icons/checked.svg'
              : 'assets/images/icons/unchecked.svg'
          "
          alt=""
          class="ml-auto" />
      </div>
    </div>
  </div>
</div>
